import {
  Component,
  ElementRef,
  forwardRef,
  NgZone,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {
  FetchArticleUsageStateType,
  FetchArticleUsageStateTypes,
} from '../../../../react/fetch/article-usage-state/fetch-article-usage-state.model';
import {ReactBaseComponent} from '../../../../react/base/react-base.component';
import {
  FetchArticleUsageStateDropdown,
} from '../../../../react/fetch/article-usage-state/fetch-article-usage-state-dropdown';

const containerElementName = 'reactFetchArticleUsageStateModal';

export const EV_ARTICLE_USAGE_STATE_DROPDOWN_INPUT = {
  provide: NG_VALUE_ACCESSOR,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  useExisting: forwardRef(() => FetchArticleUsageStateDropdownComponent),
  multi: true,
};

@Component({
    selector: 'fetch-article-usage-state-dropdown',
    template: `<div #${containerElementName}></div>`,
    providers: [EV_ARTICLE_USAGE_STATE_DROPDOWN_INPUT],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FetchArticleUsageStateDropdownComponent extends ReactBaseComponent implements ControlValueAccessor {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  selected: FetchArticleUsageStateType | null = null;

  // @formatter:off
  private _onChange = (_: any) => {};
  // @formatter:on

  constructor(private ngZone: NgZone) {
    super();
  }

  writeValue(value: any): void {
    const parsed = FetchArticleUsageStateTypes.types[value] ?? null;
    if (parsed?.state === this.selected?.state) {
      return;
    }

    this.selected = parsed;
    this.render();
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(_fn: any): void {
  }

  setDisabledState?(_isDisabled: boolean): void {
  }

  updated(usageState: FetchArticleUsageStateType): void {
    this.ngZone.run(() => {
      this.selected = usageState;
      this._onChange(this.selected?.stateString);
      this.render();
    });
  }

  protected renderComponent() {
    return <FetchArticleUsageStateDropdown selected={this.selected}
                                           selectedChanged={value => this.updated(value)}/>;
  }
}
